/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Wed Apr 03 2024 15:19:09
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { TextStyle } from '@shopify/polaris';

import conversionRateImg from 'src/assets/images/banners/search-personalization-conversion-rate.png';
import addToCartRateImg from 'src/assets/images/banners/search-personalization-add-to-cart-rate.png';
import clickThroughRateImg from 'src/assets/images/banners/search-personalization-click-through-rate.png';

const MetricsAllowcation = props => {
  const { i18n } = props;

  const metrics = [
    {
      name: 'conversation',
      weight: 'high',
      img: conversionRateImg,
      imgWidth: 140,
      imgHeight: 140
    },
    {
      name: 'add-to-cart',
      weight: 'medium',
      img: addToCartRateImg,
      imgWidth: 120,
      imgHeight: 120
    },
    {
      name: 'click-through',
      weight: 'low',
      img: clickThroughRateImg,
      imgWidth: 100,
      imgHeight: 100
    }
  ];

  return (
    <div className="metric">
      <TextStyle variation="strong">
        {i18n.translate('AdminHTML.SearchPersonalization.Metrics.title')}
      </TextStyle>
      <div className="content">
        {i18n.translate('AdminHTML.SearchPersonalization.Metrics.content')}
      </div>
      <div style={{ display: 'flex' }}>
        {metrics.map((metric, index) => {
          return (
            <div
              key={`search-personalization-metric-${index}`}
              className={`metric-box metric-box-${metric.weight}`}>
              <div className="metric-box-content">
                <div className={`metric-box-text metric-box-text-${metric.weight}`}>
                  <div className={`weight-dot weight-dot-${metric.weight}`} />
                  <div className={`metric-box-text-level-${metric.weight}`}>
                    {i18n.translate(`AdminHTML.SearchPersonalization.Metrics.${metric.weight}`)}
                  </div>
                </div>
                <div className={`metric-box-description-${metric.weight}`}>
                  <TextStyle variation="strong">
                    {i18n.translate(
                      `AdminHTML.SearchPersonalization.Metrics.metric0${index + 1}_Label`
                    )}
                  </TextStyle>
                  <div className="metric-box-description">
                    {i18n.translate(
                      `AdminHTML.SearchPersonalization.Metrics.metric0${index + 1}_Content`
                    )}
                  </div>
                </div>
              </div>
              <div className={`metric-box-image-${metric.weight}`}>
                <img
                  width={metric.imgWidth}
                  height={metric.imgHeight}
                  alt={metric.name}
                  src={metric.img}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withI18n()(MetricsAllowcation);
